(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const THRESHOLD = 0.15;

    function initSectionAnimations() {
      const sections = document.querySelectorAll('.section-wrapper');
      if (!sections.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        sections.forEach(function (s) { s.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            } else {
              entry.target.classList.remove('is-visible');
            }
          });
        },
        { threshold: THRESHOLD }
      );

      sections.forEach(function (section) {
        observer.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSectionAnimations);
    } else {
      initSectionAnimations();
    }

    document.addEventListener('shopify:section:load', initSectionAnimations);
  })();

  } catch(e) { console.error(e); }
})();
})();
